import { useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AbilityProvider } from "@iotos/ims-auth-sdk/permissions";
import { ru } from "date-fns/locale";
import { CssBaseline } from "@mui/material";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { ruRU } from "@mui/x-date-pickers/locales";

import { useAuthEvents } from "./authentication/hooks/use-auth-events";
import { getPermissionRules } from "./authentication/store/auth.selector";
import { NotificationsArea } from "./modules/notifications/containers/notifications/notifications-area";
import { useVerification } from "./modules/verification/shared/utils/use-verification";
import { AppRouter } from "./router";
import { MuiTheme } from "./styles/mui-theme";

const router = createBrowserRouter([{ path: "*", Component: AppRouter }]);

export function App() {
  // initialize verification module
  useVerification();

  // initialize auth events listener for Service Worker 401 handling
  useAuthEvents();

  const permissionRules = useSelector(getPermissionRules);

  return (
    <AbilityProvider rules={permissionRules}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={MuiTheme}>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={ru}
            localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
          >
            <CssBaseline enableColorScheme={true} />
            <RouterProvider router={router} />
            <NotificationsArea />
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </AbilityProvider>
  );
}
